export default "__VITE_ASSET__BZRwAQv5__"